














import { Component, Vue } from 'vue-property-decorator';
import LoginForm from '@/components/Account/LoginForm.vue';
import { onLogin } from '@/utils/vue-apollo';
import MountainBox from '@/components/MountainBox.vue';
import Logo from '@/components/Logo.vue';
import TabHistory from '../utils/tab-history';
import last from 'lodash/last';
import { RawLocation } from 'vue-router';
import currentUnitStore from '@/utils/current-unit-store';
import authToken from '@/utils/auth-token';
import paycheckSettingsService from '@/utils/paycheck-settings-service';
import ChangeLanguage from '@/components/Account/ChangeLanguage.vue';

@Component({
  components: {
    LoginForm,
    MountainBox,
    Logo,
    ChangeLanguage,
  },
})
export default class Login extends Vue {
   private mounted() {
    // Remove current unit from store, as it is possible that we are signing in
    // as a different user than before, so current unit will be fetched with the first
    // request.
    // This was initally done in onLogin, but in production we saw that first request to
    // fetch applicationUserData was sent with currentUnitId from previous session.
    // Now we delete this data on load of login page, and it works well.
    currentUnitStore.remove();
    authToken.remove();
    paycheckSettingsService.clearExpandedSections();
  }


  public login(token: string): void {
    onLogin(token).then(() => {
      const wantedRoute = last(TabHistory.history.filter(s => s.name !== 'Login' && s.name !== 'ConfirmPasswordReset'));
      if (wantedRoute) {
        this.$router.push(wantedRoute as RawLocation);
      } else {
        this.$router.push({ name: 'Dashboard' });
      }
    });
  }
}
